export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10891.d8cd588d.jpg";